import { RefreshResult } from "@idw-types/common";

export enum AxnAdminLoggingActionTypes {
    SET_AXN_ADMIN_LOGGING_REFRESHING = "SET_AXN_ADMIN_LOGGING_REFRESHING",
    SET_AXN_ADMIN_LOGGING_REFRESH_RESULTS = "SET_AXN_ADMIN_LOGGING_REFRESH_RESULTS"
}

type SetAxnAdminLoggingRefreshingAction = {
    type: AxnAdminLoggingActionTypes.SET_AXN_ADMIN_LOGGING_REFRESHING,
    payload: { isRefreshing: boolean; }
};

export const setAxnAdminLoggingRefreshing = (isRefreshing: boolean): SetAxnAdminLoggingRefreshingAction => ({
    type: AxnAdminLoggingActionTypes.SET_AXN_ADMIN_LOGGING_REFRESHING,
    payload: { isRefreshing }
});

type SetAxnAdminLoggingRefreshResultAction = {
    type: AxnAdminLoggingActionTypes.SET_AXN_ADMIN_LOGGING_REFRESH_RESULTS,
    payload: { refreshResults: Array<RefreshResult>; lastRefreshDate: Date; }
}

export const setAxnAdminLoggingRefreshResults = (refreshResults: Array<RefreshResult>, lastRefreshDate: Date): SetAxnAdminLoggingRefreshResultAction => ({
    type: AxnAdminLoggingActionTypes.SET_AXN_ADMIN_LOGGING_REFRESH_RESULTS,
    payload: { refreshResults, lastRefreshDate }
});


export type AxnAdminLoggingActions =
    SetAxnAdminLoggingRefreshingAction |
    SetAxnAdminLoggingRefreshResultAction